import React from 'react';
import Grid from '@mui/material/Grid';
import { Paper, Typography, Box } from '@mui/material';

const REPORTING_YEARS = [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024];

const ReportingTimeliness: React.FC<{
  company: any;
  selectedYear: number | null;
  onYearSelect: (year: number) => void;
}> = ({ company, selectedYear, onYearSelect }) => {
  const hasData = REPORTING_YEARS.some((year) => company[`${year}_SubmittedAfterTheDeadline`] !== undefined);

  if (!hasData) return null;

  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: 2, mt: 3 }}>
      <Typography variant="h6" gutterBottom>Reporting Timeliness</Typography>
      <Grid container spacing={1}>
        {REPORTING_YEARS.map((year) => {
          const isLate = company[`${year}_SubmittedAfterTheDeadline`];
          const isLateBool = isLate === true || isLate === 'True' || isLate === 'true';
          const hasReport = isLate !== undefined && isLate !== null;
          const isSelected = selectedYear === year;

          if (!hasReport) return null;

          return (
            <Grid item key={year}>
              <Box
                component="button"
                type="button"
                onClick={() => onYearSelect(year)}
                sx={{
                  textAlign: 'center',
                  border: isSelected ? '2px solid #2E25FF' : '2px solid transparent',
                  borderRadius: 2,
                  backgroundColor: 'transparent',
                  cursor: 'pointer',
                  p: 0.5,
                  minWidth: 88
                }}
              >
                <Typography variant="caption" sx={{ display: 'block', mb: 0.5, fontWeight: 'bold', color: 'text.primary' }}>{year}</Typography>
                <Box
                  sx={{
                    px: 2,
                    py: 0.5,
                    borderRadius: 1,
                    bgcolor: isLateBool ? '#FFCDD2' : '#C8E6C9',
                    color: isLateBool ? '#C62828' : '#2E7D32',
                    fontWeight: 'bold',
                    fontSize: '0.75rem'
                  }}
                >
                  {isLateBool ? 'LATE' : 'ON TIME'}
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Paper>
  );
};

export default ReportingTimeliness;
